import { Injectable } from '@angular/core';
import { Customer } from '../customer/Customer';

@Injectable({
    providedIn: 'root'
})
export class StateService {

    private accountNumber: string;
    language: string;
    customer: Customer | null;

    constructor() {}

    setAccountNumber(accountNum: string) {
        this.accountNumber = accountNum;
    }
    getAccountNumber() {
        return this.accountNumber;
    }
    setLanguage(lang: string) {
        this.language = lang;
      }
    setCustomer(c: Customer) {
    this.customer = c;
    }
    resetData() {
    this.customer = null;
    }
} 